/**
   * 😠  Just `svc-flight` things 😠
   *
   * @remarks
   * ## Standalone
   * - For a "oneWay" journey we have to use `cost` defined at the top level.
   * - For a "twoWay" journey, the top-level `cost` is only for the departing flight.
   *   We need to compute the total `cost` defined in both `departing` and `returning` items
   *
   * ## Bundled
   * - We have to use `cost` defined at the top level.
   */
export function computeFlightPrice(
  journey: App.Journey,
  isBundled: boolean,
  isTwoOneWays: boolean,
): number {
  if (isBundled) {
    return journey.cost
  }

  return (isTwoOneWays && journey.returning) ?
      (journey.departing?.cost ?? 0) + (journey?.returning?.cost ?? 0) :
    journey.cost
}
